import {request} from './request'
import {requests} from './request2'

//查询所有项目
export function queryAllProject(data){
    return request({
        url:'/queryAllProject',
        method: 'post',
        data
    })
}  

//查询学习页面的项目
export function queryStudyProject(data){
    return request({
        url: 'study/queryStudyProject',
        method: 'post',
        data
    })
}

//查询学习中项目介绍及课程列表
export function queryProjectDetails(data,data2){
    return request({
        url: 'study/queryProjectDetails?projectId='+data+'&userId='+data2,
        method: 'get',
    })
}

//查询试卷题目
export function queryExamList(data){
    return request({
        url: 'exam/queryExamList',
        method: 'post',
        data
    })
}

//开始考试
export function startExam(data){
    return request ({
        url: "exam/startExam",
        method: 'post',
        data
    })
}

//保存用户做的题目
export function saveTopic(data){
    return request ({
        url: "exam/saveTopic",
        method: 'post',
        data
    })
}

//考试结束
export function endExam(data){
    return request ({
        url: "exam/endExam",
        method: 'post',
        data
    })
}

//查询项目问卷
export function queryProjectVote(data){
    return requests({
        url: 'study/queryProjectVote?voteId='+data,
        method: 'get',
    })
}

//保存问卷答案
export function addVoteAnswer(data,id){
    return requests({
        url: `study/addVoteAnswer?projectId=${id}`,
        method: 'post',
        data
    })
}

//查询项目信息
export function findProject(data){
    return request ({
        url: "editCredit/findProject?orderNo="+data,
        method: 'post',
    })
}

//增加学时下单
export function editCreditOrder(data){
    return request ({
        url: "editCredit/editCreditOrder",
        method: 'post',
        data
    })
}